import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './index';

interface ListNumberingState {
  // scopeId -> (key -> currentNumber)
  scopes: Record<string, Record<string, number>>;
}

const initialState: ListNumberingState = {
  scopes: {},
};

const makeKey = (numId: number, level: number) => `${numId}-${level}`;

const listNumberingSlice = createSlice({
  name: 'listNumbering',
  initialState,
  reducers: {
    resetNumbering(state, action: PayloadAction<{ scopeId: string }>) {
      state.scopes[action.payload.scopeId] = {};
    },
    setCurrent(
      state,
      action: PayloadAction<{ scopeId: string; numId: number; level: number; value: number }>
    ) {
      const { scopeId, numId, level, value } = action.payload;
      const scope = (state.scopes[scopeId] = state.scopes[scopeId] || {});
      scope[makeKey(numId, level)] = value;
    },
  },
});

export const { resetNumbering, setCurrent } = listNumberingSlice.actions;

export const selectListNumbering = (state: RootState) => state.listNumbering;

export default listNumberingSlice.reducer;

